// Note: Remove require packages in package.json if exported as external modules
import axios from 'axios';
import jwt from 'jsonwebtoken';

function refreshTokens (tokenOption, http) {
  return new Promise((resolve, reject) => {
    this.acquireToken(tokenOption)
      .then((accessToken) => {
        http.defaults.headers[tokenOption.name] = accessToken;
        resolve(http.defaults.headers[tokenOption.name]);
      }).catch(reject);
  });
}

class AxiosAuthHttp {
  acquireToken (tokenOption) {
    return new Promise((resolve, reject) => {
      jwt.sign(
        tokenOption.body,
        tokenOption.salt,
        {
          expiresIn: tokenOption.ttl,
        },
        (err, token) => {
          if (err) {
            reject(err);
          }
          resolve(token);
        }
      );
    });
  }

  create (options) {
    if (options == null) {
      throw new Error('Provided `options` for auth-http are null !');
    }

    if (options.token == null) {
      throw new Error('Provided `options.token` for auth-http is null !');
    }

    if (options.token.name == null) {
      throw new Error('A `options.token.name` is required');
    }

    if (options.token.body == null) {
      throw new Error('An `options.token.body` is required');
    }

    if (options.token.salt == null) {
      throw new Error('An `options.token.salt` is required');
    }

    if (options.token.ttl == null) {
      throw new Error('An `options.token.ttl` is required');
    }

    const http = axios.create({
      baseURL: options.baseUrl,
      headers: options.headers,
    });

    http.interceptors.request.use(req => refreshTokens.call(this, options.token, http)
      .then(() => {
        req.headers[options.token.name] = http.defaults.headers[options.token.name];
        return req;
      }), error => Promise.reject(error));

    return http;
  }
}

export default new AxiosAuthHttp();
